// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { VitalSignTypeComponent } from './vitalSignTypeComponent';

/**
 * Serializes Vital Sign Types from database.
 * @see #/components/schemas/VitalSignType - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface VitalSignType {
    readonly code: string;
    /**
     * The display name for the vital sign
     *
     */
    display_name: string;
    /**
     * The type for the vital sign  * `integer` - Ganzzahl * `decimal` - Decimal * `text` - Text * `boolean` - Boolean * `group` - Group
     *
     */
    type: VitalSignType.TypeEnum;
    /**
     * The unit for the vital sign (required for integer and decimal types)
     *
     */
    unit?: string;
    /**
     * The visibility for the vital sign
     *
     */
    is_visible?: boolean;
    readonly components: Array<VitalSignTypeComponent>;
    /**
     * Whether Vital Sign Types is automated.
     *
     */
    readonly is_automated: boolean;
    chart_color_light_mode?: string;
    chart_color_dark_mode?: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for VitalSignType
 */
export namespace VitalSignType {
    export type TypeEnum = 'integer' | 'decimal' | 'text' | 'boolean' | 'group';
    export const TypeEnum = {
        Integer: 'integer' as TypeEnum,
        Decimal: 'decimal' as TypeEnum,
        Text: 'text' as TypeEnum,
        Boolean: 'boolean' as TypeEnum,
        Group: 'group' as TypeEnum,
    };

    /**
     * VitalSignType Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        readonly code: string;
        /**
         * The display name for the vital sign
         * @type string (`dataFormat` is missing)
         */
        displayName: string;
        /**
         * The type for the vital sign  * `integer` - Ganzzahl * `decimal` - Decimal * `text` - Text * `boolean` - Boolean * `group` - Group
         * @type string (`dataFormat` is missing)
         */
        type: VitalSignType.TypeEnum;
        /**
         * The unit for the vital sign (required for integer and decimal types)
         * @type string (`dataFormat` is missing)
         */
        unit?: string;
        /**
         * The visibility for the vital sign
         * @type boolean (`dataFormat` is missing)
         */
        isVisible?: boolean;
        @Type(() => VitalSignTypeComponent.Model) readonly components: Array<VitalSignTypeComponent.Model>;
        /**
         * Whether Vital Sign Types is automated.
         * @type boolean (`dataFormat` is missing)
         */
        readonly isAutomated: boolean;
        chartColorLightMode?: string;
        chartColorDarkMode?: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * VitalSignType DTO
     * Transforms VitalSignType model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend VitalSignType model */
        static toModel(obj: VitalSignType): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend VitalSignType model */
        static toApi(obj: Model): VitalSignType {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as VitalSignType;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
